import * as React from "react"

export const Header: React.FC = () => {
    return (
        <div className="flex min-h-[52px] h-[104px] items-center justify-center w-full bg-[linear-gradient(90deg,rgba(147,197,253,0.12)_0%,rgba(196,181,253,0.12)_38%,rgba(236,72,153,0.12)_67.83%,rgba(253,186,116,0.12)_100%)]">
            {/* Light mode logo - visible by default, hidden in dark mode */}
            <img
                src="assets/logo_black.png"
                alt="Company Logo"
                className="h-8 w-auto object-contain dark:hidden"
            />
            {/* Dark mode logo - hidden by default, visible in dark mode */}
            <img
                src="assets/logo_white.png"
                alt="Company Logo"
                className="h-8 w-auto object-contain hidden dark:block"
            />
        </div>
    )
}